// Every `import { z } from "zod"` in this app actually lands here, via the
// `^zod$` alias in vite.config.ts. The wrapper sets jitless before re-exporting.
//
// Why: Zod 4 probes `new Function("")` to decide whether it may JIT-compile
// validators. Our CSP has no 'unsafe-eval', so the probe throws (Zod catches
// it) and Chrome still logs the blocked eval as a DevTools issue — the one
// thing keeping Lighthouse's best-practices score at 96. `jitless` skips the
// probe; validation is identical, just interpreted.
//
// Why an alias and not a plain `z.config(...)` call somewhere early: the probe
// result is read when a schema is CONSTRUCTED, and route modules construct
// their search validators at import time. Two earlier attempts failed —
// a config call in router.tsx's module body ran after the route imports, and
// a side-effect-only first import ("./zod-config") was dropped entirely by the
// route-entry transform (verified: `jitless:!0` was absent from the built
// bundle). The alias cannot be skipped: any module that wants `z` evaluates
// this file first, and the exports below keep the call from being tree-shaken.
import { z } from "zod/v4";

z.config({ jitless: true });

export * from "zod/v4";
export default z;
